import axios from 'axios'
import util from '../util'

const params = util.getCurUrlParameter()
const headers = {}
if (params.device === 'iosapp') {
  headers['Device-Id'] = params.deviceId
  headers.Ticket = params.ticket
}

export default axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    ...headers
  }
})
